// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"a6673424","131":"9b998504"}[chunkId] + ".chunk.js";
};